import { fromJS } from 'immutable';

// eslint-disable-next-line no-restricted-imports -- pre-existing action-creator apiClient usage; migrate to api/<domain>.js when touched
import apiClient from '@sophocles/http-common';
import { checkHttpStatus, genericErrorAction } from '@sophocles/utils';

export const REQUEST_STATION_INFO = 'REQUEST_STATION_INFO';
function requestStationInfo(values) {
  return {
    type: REQUEST_STATION_INFO,
    values: values,
  };
}

export function rawFetchStationInfo(latitude, longitude, distance) {
  return dispatch => {
    const values = { latitude, longitude, distance };
    dispatch(requestStationInfo(values));
    return apiClient
      .post(`/weatherlookup/`, values)
      .then(checkHttpStatus)
      .then(response => fromJS(response.data))
      .catch(error => dispatch(genericErrorAction(error, REQUEST_STATION_INFO)));
  };
}
